"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
var _utils = require("../utils");
var _loading = _interopRequireDefault(require("../loading"));
var _stance = _interopRequireDefault(require("../stance"));
var _iphoneX = require("../mixins/iphone-x");
var _bindEvent = require("../mixins/bind-event");
var _scroll = require("../utils/scroll");
var _use = (0, _utils.use)('list'),
  sfc = _use[0],
  bem = _use[1];
var _default = sfc({
  mixins: [_iphoneX.iPhoneXMixin, (0, _bindEvent.BindEventMixin)(function (bind) {
    if (!this.scroller) {
      this.scroller = (0, _scroll.getScrollEventTarget)(this.$el);
    }
    bind(this.scroller, 'scroll', this.check);
  })],
  model: {
    prop: 'loading'
  },
  props: {
    error: Boolean,
    loading: Boolean,
    finished: Boolean,
    reverseMode: Boolean,
    loadingText: String,
    errorText: {
      type: String,
      default: '加载失败，点击重试'
    },
    // 开启后结束文案会固定在底部
    finishedTextFixed: {
      type: Boolean,
      default: false
    },
    finishedText: {
      type: String,
      default: '到底了'
    },
    finishedImg: {
      type: String,
      default: 'https://pic3.zhuanstatic.com/zhuanzh/n_v24fc611d42e03423a9270f51e4a0c2b6c.png'
    },
    showFinishedImg: {
      type: Boolean,
      default: true
    },
    immediateCheck: {
      type: Boolean,
      default: true
    },
    offset: {
      type: Number,
      default: 300
    },
    enableViewPortCheck: {
      type: Boolean,
      default: false
    },
    stanceDescText: {
      type: String,
      default: '内容加载失败，请点击页面重试'
    }
  },
  data: function data() {
    return {
      // use sync innerLoading state to avoid repeated loading in some edge cases
      innerLoading: this.loading
    };
  },
  updated: function updated() {
    this.innerLoading = this.loading;
  },
  mounted: function mounted() {
    if (this.immediateCheck) {
      this.check();
    }
  },
  watch: {
    loading: 'check',
    finished: 'check'
  },
  methods: {
    check: function check() {
      var _this = this;
      this.$nextTick(function () {
        if (_this.innerLoading || _this.finished || _this.error) {
          return;
        }
        if (_this.reverseMode) {
          _this.fixScrollTop();
        }
        var el = _this.$el,
          scroller = _this.scroller,
          offset = _this.offset;
        var scrollerRect;
        if (scroller.getBoundingClientRect) {
          scrollerRect = scroller.getBoundingClientRect();
        } else {
          scrollerRect = {
            top: 0,
            bottom: scroller.innerHeight
          };
        }
        var scrollerHeight = scrollerRect.bottom - scrollerRect.top;
        if (!scrollerHeight || window.getComputedStyle(el).display === 'none' || el.offsetParent === null) {
          return;
        }
        var isReachEdge = false;
        if (_this.reverseMode) {
          var placeholderRect = _this.$refs.topPlaceholder.getBoundingClientRect();
          isReachEdge = scrollerRect.top - placeholderRect.top <= offset;
        } else {
          var _placeholderRect = _this.$refs.btmPlaceholder.getBoundingClientRect();
          // isInViewPort判断占位元素是否在视窗内，解决tabs组件内嵌list组件时的联动触发加载问题，开启enableViewPortCheck才生效
          var flag = !_this.enableViewPortCheck || (0, _utils.isInViewPort)(_this.$refs.btmPlaceholder);
          isReachEdge = _placeholderRect.bottom - scrollerRect.bottom <= offset && flag;
        }
        if (isReachEdge) {
          _this.innerLoading = true;
          _this.$emit('input', true);
          _this.$emit('load');
          if (_this.reverseMode) {
            // 等待loading框出现
            setTimeout(function () {
              _this.scrollHeight = (0, _scroll.getScrollHeight)(_this.scroller);
            });
          }
        }
      });
    },
    fixScrollTop: function fixScrollTop() {
      if (!this.scrollHeight) return;
      var newScrollHeight = (0, _scroll.getScrollHeight)(this.scroller);
      this.scroller.scrollBy(0, newScrollHeight - this.scrollHeight);
      this.scrollHeight = 0;
    },
    clickErrorText: function clickErrorText() {
      this.$emit('update', false);
      this.check();
    },
    isShowLoading: function isShowLoading() {
      var _this$$refs$list;
      return ((_this$$refs$list = this.$refs.list) === null || _this$$refs$list === void 0 ? void 0 : _this$$refs$list.offsetHeight) > 400;
    }
  },
  render: function render(h) {
    return h("div", {
      "class": [bem(), this.isiPhoneX && 'z-iphone-x'],
      "ref": "list"
    }, [h("div", {
      "ref": "topPlaceholder",
      "class": bem('placeholder')
    }), !this.reverseMode && (this.finishedTextFixed ? h("div", {
      "class": "finished-fixed",
      "style": "min-height: calc(100% - 70px)"
    }, [this.slots()]) : this.slots()), this.innerLoading && !this.finished && h("div", {
      "class": bem('loading-text', {
        first: !this.isShowLoading()
      })
    }, [this.slots('loading') || h(_loading.default, {
      "attrs": {
        "type": "page"
      }
    })]), this.finished && (this.$slots.finish || this.finishedText) && h("div", {
      "class": bem('finished-text', {
        small: !this.$slots.finish && this.showFinishedImg
      })
    }, [this.slots('finish') || [this.finishedText]]), this.error && (this.$slots.error || this.errorText) && h("div", {
      "on": {
        "click": this.clickErrorText
      },
      "class": bem('error-text')
    }, [this.slots('error') || !this.isShowLoading() ? h(_stance.default, {
      "attrs": {
        "type": "data",
        "show-btn": false,
        "show-info": false,
        "desc-text": this.stanceDescText
      }
    }) : this.errorText]), this.reverseMode && this.slots(), h("div", {
      "ref": "btmPlaceholder",
      "class": bem('placeholder')
    })]);
  }
});
exports.default = _default;